export type Theme = 'light' | 'dark' | 'system';

export function readTheme(): Theme {
  try {
    const t = localStorage.getItem('ft-theme');
    return t === 'light' || t === 'dark' ? t : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(t: Theme): void {
  const r = document.documentElement;
  if (t === 'system') r.removeAttribute('data-theme');
  else r.setAttribute('data-theme', t);
  try {
    if (t === 'system') localStorage.removeItem('ft-theme');
    else localStorage.setItem('ft-theme', t);
  } catch {
    /* Speicher gesperrt: Theme gilt nur für diese Sitzung */
  }
}

export function isDark(t: Theme): boolean {
  return t === 'dark' || (t === 'system' && matchMedia('(prefers-color-scheme: dark)').matches);
}
